import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { DarkModeContext } from "../context/DarkModeContext";
import "bootstrap-icons/font/bootstrap-icons.css";
import menDP from "../images/men.png";
import Header from "../components/Header";

export default function About() {
    const { darkMode, toggleDarkMode } = useContext(DarkModeContext);
    const location = useLocation();

    const skills = [
        { icon: "bi-filetype-html", name: "HTML5" },
        { icon: "bi-filetype-css", name: "CSS3" },
        { icon: "bi-filetype-php", name: "PHP" },
        { icon: "bi-filetype-js", name: "JavaScript" },
        { icon: "bi-filetype-jsx", name: "React" },
        { icon: "bi-filetype-jsx", name: "Node.js" },
        { icon: "bi-filetype-jsx", name: "Next.ja" },
        { icon: "bi-filetype-jsx", name: "Vue.js" },
        { icon: "bi-filetype-jsx", name: "AWS S3" },
        { icon: "bi-filetype-jsx", name: "MongoDB" },
        { icon: "bi bi-filetype-sql", name: "MySQL" },
    ];

    const languages = [
        { name: "Pashto", proficiency: 100 },
        { name: "Urdu", proficiency: 100 },
        { name: "English", proficiency: 90 },
    ];


    const FooterContacts = [
        { icon: "bi-whatsapp", color: "#25D366", link: "https://wa.me/03078005419", target: "_blank", },
        { icon: "bi-envelope-at-fill", color: "#EA4335", link: "mailto:zahoorulhaq37@gmail.com", target: "_blank" },
    ];

    const FooterSocialLinks = [
        { icon: "bi-linkedin", link: "https://www.linkedin.com/in/zahoor-ul-haq-b0058b10a/", target: "_blank" },
        { icon: "bi-twitter-x", link: "https://x.com/yourusername", target: "_blank" },
        { icon: "bi-instagram", link: "https://www.instagram.com/zahoor_ig?igsh=MWx0ZHhxdHlqMzc2Yg==", target: "_blank" },

    ];

    const stats = [
        { number: "4+", label: "Years Experience", icon: "bi-calendar-check" },
        { number: "5+", label: "Projects Completed", icon: "bi-kanban" },
        // { number: "15+", label: "Happy Clients", icon: "bi-people" },
    ];

    return (
        <div className={`${darkMode ? "bg-dark text-white" : "bg-white text-dark"} min-vh-100 w-100`}>
            <div className="container py-4">
            <Header />

                <div className="container py-5">
                    <div className="row g-5 align-items-start">

                        <div className="col-lg-5">
                            <div className="position-relative">
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100"
                                    style={{
                                        background: "linear-gradient(135deg, #edd817a6 0%, #e9f817bb 100%)",
                                        clipPath: "polygon(0 30%, 100% 0, 100% 80%, 0 100%)",
                                        zIndex: 0,
                                        height: "120%",
                                        top: "-10%"
                                    }}
                                ></div>

                                <div className="position-relative z-1 text-center p-4">
                                    <img
                                        src={menDP}
                                        alt="Zahoor Ul Haq"
                                        className="img-fluid rounded-circle shadow-lg mb-4"
                                        style={{
                                            width: "250px",
                                            height: "250px",
                                            objectFit: "cover",
                                            border: "5px solid white"
                                        }}
                                    />

                                    <div className={`p-4 ${darkMode ? "bg-dark" : "bg-light"} shadow-sm rounded-5`}>
                                        <h3 className="fw-bold mb-1">Zahoor Ul Haq</h3>
                                        <p className="text-warning fw-semibold mb-3">Full Stack Developer</p>

                                        <div className="text-start small">
                                            <p className="mb-2"><i className="bi bi-geo-alt me-2 text-warning"></i>Islamabad, Pakistan</p>
                                            <p className="mb-2"><i className="bi bi-telephone me-2 text-warning"></i>+92-3078005419</p>
                                            <p className="mb-2"><i className="bi bi-envelope me-2 text-warning"></i>zahoorulhaq37@gmail.com</p>
                                            <p className="mb-0"><i className="bi bi-mortarboard me-2 text-warning"></i>BS Software Engineering</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7">

                            <div className="mb-5">
                                <h5 className="text-uppercase  small fw-bold mb-3 tracking-wide bg-warning bg-opacity-75 text-dark badge">
                                    Languages
                                </h5>

                                <div className="row g-3 mb-4">
                                    {languages.map((lang, idx) => (
                                        <div className="col-4 text-center" key={idx}>
                                            <div className="position-relative d-inline-block">
                                                <svg width="80" height="80" viewBox="0 0 80 80">
                                                    <circle
                                                        cx="40"
                                                        cy="40"
                                                        r="35"
                                                        fill="none"
                                                        stroke="#efac38c3"
                                                        strokeWidth="8"
                                                        strokeDasharray={`${2 * Math.PI * 35}`}
                                                        strokeDashoffset={`${2 * Math.PI * 35 * (1 - lang.proficiency / 100)}`}
                                                        strokeLinecap="round"
                                                        transform="rotate(-90 40 40)"
                                                    />
                                                </svg>
                                                <div className="position-absolute top-50 start-50 translate-middle">
                                                    <span className="fw-bold fs-5 text-secondary">{lang.proficiency}%</span>
                                                </div>
                                            </div>
                                            <p className="fw-semibold mb-0 mt-2">{lang.name}</p>
                                        </div>
                                    ))}
                                </div>
                                <div className="bg-white mb-3" style={{ height: "3px", width: "100%" }}></div>

                                <div className="row g-3 mt-3">
                                    {stats.map((stat, idx) => (
                                        <div className="col-4" key={idx}>
                                            <div className={`p-3 rounded-3 text-center ${darkMode ? "bg-secondary bg-opacity-25" : "bg-light"}`}>
                                                <i className={`bi ${stat.icon} text-warning mb-1`} style={{ fontSize: "20px" }}></i>
                                                <h6 className="fw-bold mb-0">{stat.number}</h6>
                                                <small className={`${darkMode ? "text-white-50" : "text-secondary"}`}>
                                                    {stat.label}
                                                </small>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                            <div className="bg-white mb-3" style={{ height: "3px", width: "100%" }}></div>

                            <div className="mb-5">
                                <h5 className="text-uppercase text-black bg-warning bg-opacity-75 badge small fw-bold mb-3 tracking-wide ">Skills & Tools</h5>
                                <div className="d-flex flex-wrap gap-2">
                                    {skills.map((skill, idx) => (
                                        <span
                                            key={idx}
                                            className={`badge rounded-pill px-3 py-2 ${darkMode ? "bg-secondary text-white" : "bg-light text-dark border"}`} >
                                            <i className={`bi ${skill.icon} me-1`}></i>
                                            {skill.name}
                                        </span>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <footer className={`${darkMode ? "bg-dark text-white" : "bg-light text-dark"} py-5 border-top border-secondary border-opacity-25`}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-3">
                                {FooterContacts.map((item, idx) => (
                                    <a
                                        key={idx}
                                        href={item.link || "#"}
                                        target={item.target}
                                        rel={item.target ? "noopener noreferrer" : undefined}
                                        className="text-decoration-none  d-flex align-items-center gap-2 px-3 py-2 ">
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center shadow border"
                                            style={{ width: "45px", height: "45px", backgroundColor: item.color }}>
                                            <i className={`bi ${item.icon} text-white fs-6`}></i>
                                        </div>
                                        <span className={`fw-semibold small ${darkMode ? "text-white-50" : "text-secondary"}`}>
                                            {item.label}
                                        </span>
                                    </a>
                                ))}

                                <div className="border-start border-warning border-opacity-75 mx-2" style={{ height: "35px" }}></div>

                                {FooterSocialLinks.map((social, idx) => (
                                    <a
                                        key={idx}
                                        href={social.link}
                                        target={social.target}
                                        rel="noopener noreferrer"
                                        className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border"
                                        style={{ width: "45px", height: "45px", backgroundColor: "#ffc107" }}>
                                        <i className={`bi ${social.icon} fs-5 text-dark`}></i>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </footer>

            </div>
        </div>
    );
}